import { render } from "./FIRSTRobot.vue?vue&type=template&id=f0f20bae&scoped=true"
import script from "./FIRSTRobot.vue?vue&type=script&lang=js"
export * from "./FIRSTRobot.vue?vue&type=script&lang=js"

import "./FIRSTRobot.vue?vue&type=style&index=0&id=f0f20bae&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f20bae"]])

export default __exports__